<ion-header>
  <ion-toolbar class="ion-text-center">
    <ion-title [class.dev-mode]="authService.core.DEV_MODE" (click)="authService.core.enableDevMode()"
      >Settings</ion-title
    >

    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="close()">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list class="general-list" lines="none">
    <!-- KEEP AWAKE -->
    <ion-item class="item-preference">
      <ion-label class="item-preference-label">
        Keep awake
        <p class="description" col-12>Prevent the screen of the device from falling asleep</p>
      </ion-label>

      <ion-toggle
        mode="ios"
        (ionChange)="changeSetting('general', 'keep_awake', $event.detail.checked)"
        [checked]="cloneSetting.general.keep_awake"
        slot="end"
      ></ion-toggle>
    </ion-item>

    <!-- APP VOLUME -->
    <ion-item class="item-preference">
      <ion-label class="item-preference-label">
        Always max volume
        <p class="description" col-12>Always sets the device volume to MAX</p>
      </ion-label>

      <ion-toggle
        mode="ios"
        (ionChange)="changeSetting('general', 'force_max_volume', $event.detail.checked)"
        [checked]="cloneSetting.general.force_max_volume"
        slot="end"
      ></ion-toggle>
    </ion-item>

    <!-- SHOW YESTERDAY -->
    <ion-item class="item-preference">
      <ion-label class="item-preference-label">
        Show orders from yesterday
        <p class="description" col-12>Include displaying orders from yesterday</p>
      </ion-label>

      <ion-toggle
        mode="ios"
        (ionChange)="changeSetting('general', 'show_yesterday_orders', $event.detail.checked)"
        [checked]="cloneSetting.general.show_yesterday_orders"
        slot="end"
      ></ion-toggle>
    </ion-item>

    <!-- DARK MODE -->
    <ion-item class="item-preference">
      <ion-label class="item-preference-label">
        Dark mode
        <p class="description" col-12>Change the app theme to dark</p>
      </ion-label>

      <ion-toggle
        mode="ios"
        (ionChange)="changeSetting('general', 'dark_mode', $event.detail.checked)"
        [checked]="cloneSetting.general.dark_mode"
        slot="end"
      ></ion-toggle>
    </ion-item>
    <br />

    <ion-item class="item-preference">
      <div class="item-pref-cta-container ion-text-center">
        <ion-button color="secondary" class="hub-btn" (click)="contactSupport()"> Submit a ticket </ion-button>
      </div>
    </ion-item>
  </ion-list>
</ion-content>

<ion-footer class="ion-text-center hub-btn-container">
  <ion-button class="hub-btn" fill="clear" (click)="close()"> Cancel </ion-button>
  <ion-button class="hub-btn" (click)="save()"> Apply Settings </ion-button>
</ion-footer>
